import { render, staticRenderFns } from "./CtaSection.vue?vue&type=template&id=5531c8d5&scoped=true&"
import script from "./CtaSection.vue?vue&type=script&lang=js&"
export * from "./CtaSection.vue?vue&type=script&lang=js&"
import style0 from "./CtaSection.vue?vue&type=style&index=0&id=5531c8d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5531c8d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VForm,VRow,VTextField})
